import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
import _get from "lodash/get";

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n        max-width: ", ";\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["(min-width: ", ")"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["(min-width: ", ")"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["(min-width: ", ")"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["(min-width: ", ")"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["(min-width: ", ")"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["(min-width: ", ")"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';
import { rem } from 'polished';
import layoutTheme from './layoutTheme'; // Media Queries
// https://github.com/styled-components/styled-components/issues/791

var mediaQ = function mediaQ() {
  for (var _len = arguments.length, query = new Array(_len), _key = 0; _key < _len; _key++) {
    query[_key] = arguments[_key];
  }

  return function () {
    return css(["@media ", "{", "}"], css.apply(void 0, query), css.apply(void 0, arguments));
  };
};

export var media = {
  xxs: mediaQ(_templateObject(), function (_ref) {
    var theme = _ref.theme;
    return rem(_get(theme, 'layout.media.xxs', layoutTheme.layout.media.xxs));
  }),
  xs: mediaQ(_templateObject2(), function (_ref2) {
    var theme = _ref2.theme;
    return rem(_get(theme, 'layout.media.xs', layoutTheme.layout.media.xs));
  }),
  sm: mediaQ(_templateObject3(), function (_ref3) {
    var theme = _ref3.theme;
    return rem(_get(theme, 'layout.media.sm', layoutTheme.layout.media.sm));
  }),
  md: mediaQ(_templateObject4(), function (_ref4) {
    var theme = _ref4.theme;
    return rem(_get(theme, 'layout.media.md', layoutTheme.layout.media.md));
  }),
  lg: mediaQ(_templateObject5(), function (_ref5) {
    var theme = _ref5.theme;
    return rem(_get(theme, 'layout.media.lg', layoutTheme.layout.media.lg));
  }),
  xl: mediaQ(_templateObject6(), function (_ref6) {
    var theme = _ref6.theme;
    return rem(_get(theme, 'layout.media.xl', layoutTheme.layout.media.xl));
  })
}; // Container and Site Container
// Experimental, moving away from Btsp container as we only use container-fluid with a max-width on larger screens

export var container = function container() {
  return css(["margin-left:auto;margin-right:auto;overflow:hidden;padding-left:", ";padding-right:", ";"], function (_ref7) {
    var theme = _ref7.theme;
    return rem(_get(theme, 'layout.grid.gutter', layoutTheme.layout.grid.gutter));
  }, function (_ref8) {
    var theme = _ref8.theme;
    return rem(_get(theme, 'layout.grid.gutter', layoutTheme.layout.grid.gutter));
  });
};
export var siteContainer = function siteContainer() {
  return css(["", " ", ""], container, media.md(_templateObject7(), function (_ref9) {
    var theme = _ref9.theme;
    return rem(_get(theme, 'layout.maxSiteWidth', layoutTheme.layout.maxSiteWidth));
  }));
};